import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { Modal, ModalBody } from 'reactstrap';

import JobcaseLogo from "assets/img/vectors/logo/jobcase.png";


const JCNotification = ({ className, setShowJobcase, history, location }) => {

    Object.defineProperty(document, "referrer", {
        configurable: true,
        enumerable: true,
        value: document.referrer,
    });

    const onCloseModal = () => {
        setShowJobcase(false);
        history.push(location.pathName);
        Object.defineProperty(document, "referrer", {get : function(){ return "Upward.net/employers"; }});
    }

    return (
        <Modal isOpen={true} className={(className ? className : "") + " rounded_modal signin-modal"} style={{ "height": "100%" }} toggle={onCloseModal} keyboard={true} >
            <button type="button" onClick={onCloseModal} className="close modalClose" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <ModalBody>
                    <Fragment>
                        <div className="py-1 rounded mb-4"><img className="rounded" src={JobcaseLogo} alt="We help you hire smarter" /></div>
                        <div className="py-1 rounded mb-2">
                            <h4 style={{ "font-weight": "bold" }}>Welcome to Upward,<br />
                            a Jobcase company</h4>
                        </div>
                        <div className="py-1 rounded mb-4" style={{ "fontSize": "1rem" }}>
                            To post your job, just share the details with our great job-matching engine, Upward. We'll help you find the perfect workers for your positions - fast.
                        </div>
                        <div className="float-left">
                            <button style={{ "fontSize": "1rem" }} onClick={onCloseModal} className="px-3 py-3 btn btn-xl btn-block btn-dark-orange mb-4">Let's get started</button>
                        </div>
                    </Fragment>
            </ModalBody>
        </Modal>
    )

}


export default withRouter(JCNotification);
